/**
 * Make promise handling easier
 */
export class Deferred<T = any> {
    constructor() {
        this._promise = new Promise<T>((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
    }

    /**
     * The promise
     */
    public get promise() {
        return this._promise;
    }
    private readonly _promise: Promise<T>;

    /**
     * Resolve the promise with the specified value
     */
    public resolve(value?: T | PromiseLike<T>) {
        if (this.isCompleted) {
            throw new Error('Already completed');
        }
        this._resolve(value);
    }
    private _resolve: (value?: T | PromiseLike<T>) => void;

    /**
     * Reject the promise with the specified value
     */
    public reject(value?: T | PromiseLike<T>) {
        if (this.isCompleted) {
            throw new Error('Already completed');
        }
        this._reject(value);
    }
    private _reject: (value?: T | PromiseLike<T>) => void;

    /**
     * Is the promise resolved?
     */
    public get isResolved() {
        return this._isResolved;
    }
    private readonly _isResolved = false;

    /**
     * Is the promise rejected?
     */
    public get isRejected() {
        return this._isRejected;
    }
    private readonly _isRejected = false;

    /**
     * Is the promise resolved or rejected?
     */
    public get isCompleted() {
        return this._isResolved || this.isRejected;
    }
}
